import { DownloadFile, enqueueSnackbar, UploadFile, UploadFiles, FetchDownloads } from 'actions';
import {
	GetClustersInfoRequest,
	GetClusterStringRequest,
	GetSiteListDatesRequest,
	GetSiteListRequest
} from '../requests/HostToolsRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const RESET_FIELDS = 'RESET_FIELDS';
export const GET_CLUSTERS_INFO = 'GET_CLUSTERS_INFO';
export const GET_SITE_LIST_DATES = 'GET_SITE_LIST_DATES';

const onSetFormState = value => ({
	type: SET_FORM_STATE,
	formState: value
});

const onResetFields = () => ({
	type: RESET_FIELDS
});

const onGetClustersInfo = value => ({
	type: GET_CLUSTERS_INFO,
	clustersInfo: value
});

const onGetSiteListDates = value => ({
	type: GET_SITE_LIST_DATES,
	siteListDates: value
});

export const SetFormState = value => dispatch => {
	dispatch(onSetFormState(value));
};

export const ResetFields = () => dispatch => {
	dispatch(onResetFields());
};

export const GetClustersInfo = (userId) => async dispatch => {
	await GetClustersInfoRequest(userId)
		.then(response => {
			dispatch(onGetClustersInfo(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetClusterString = (userId, mocnActivationDates, host) => async dispatch => {
	await GetClusterStringRequest(userId, mocnActivationDates, host)
		.then(response => {
			dispatch(DownloadFile(response.data));
			dispatch(enqueueSnackbar({ message: 'Files Complete', options: { variant: 'info' } }));

		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

// SiteList
export const GetSiteListDates = (userId) => async dispatch => {
	await GetSiteListDatesRequest(userId)
		.then(response => {
			dispatch(onGetSiteListDates(response.data));
		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};

export const GetSiteList = (userId, mocnActivationDateF) => async dispatch => {
	await GetSiteListRequest(userId, mocnActivationDateF)
		.then(response => {
			dispatch(DownloadFile(response.data));
			dispatch(enqueueSnackbar({ message: 'Files Complete', options: { variant: 'info' } }));

		})
		.catch(error => {
			if (error) {
				dispatch(
					enqueueSnackbar({
						message: error.message,
						options: { variant: error.variant }
					})
				);
			}
		});
};
